import { Injectable } from '@angular/core';

import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { isObject } from 'util';
import { cloneDeep } from 'lodash';

import { NotifierService } from 'angular-notifier';

import * as ConfigActions from '../actions/config';

import { State } from '../reducers';
import { TranslateService } from '../../i18n/services/translate.service';
import { ConfigService } from '../../services/config/config.service';
import { Config } from '../../services/config/models/config';
import { XenaGlobalConfig } from '../../services/config/models/xena-global-config';
import { UraniaConfig } from '../../services/config/models/urania-config';
import { NeoConfig } from '../../services/config/models/neo-config';




@Injectable()
export class ConfigEffects {
	@Effect({ dispatch: false }) loadConfig$ = this._actions$
		.ofType<ConfigActions.LoadConfig>(ConfigActions.LOAD_CONFIG)
		.map(action => action.scope)
		.do(scope => {
			this._config.retrieveConfig(scope)
				.catch(() => {
					this._store.dispatch(new ConfigActions.LoadConfigError(scope));
					return Observable.of(null);
				})
				.take(1)
				.subscribe(c => {
					if (isObject(c)) {
						this._store.dispatch(new ConfigActions.LoadConfigSuccess(scope, c.config, c.revision));
					}
				});
		});

	@Effect() saveConfig$ = this._actions$
		.ofType<ConfigActions.SaveConfig>(ConfigActions.SAVE_CONFIG)
		.switchMap(action => {
			const configToBeSaved: Config|XenaGlobalConfig|UraniaConfig|NeoConfig = cloneDeep(action.payload);

			return this._config.saveConfig(action.scope, action.payload)
				.map(conf => new ConfigActions.SaveConfigSuccess(action.scope, configToBeSaved, conf.revision))
				.catch(() => Observable.of(new ConfigActions.SaveConfigError(action.scope)));
		});

	@Effect() saveAgentConfig$ = this._actions$
		.ofType<ConfigActions.SaveAgentConfig>(ConfigActions.SAVE_AGENT_CONFIG)
		.switchMap(action => {
			const configToBeSaved: Partial<Config | XenaGlobalConfig | UraniaConfig | NeoConfig> = cloneDeep(action.payload);

			return this._config.saveAgentConfig(action.scope, action.payload)
				.map(conf => new ConfigActions.SaveConfigSuccess(action.scope, configToBeSaved, conf.revision, true))
				.catch(() => Observable.of(new ConfigActions.SaveConfigError(action.scope)));
		});

	@Effect() setConfig$ = this._actions$
		.ofType<ConfigActions.SetTempConfig>(ConfigActions.SET_TEMP_CONFIG)
			.map(action => new ConfigActions.SetTempConfigSuccess(action.scope, action.payload))
			.catch(action => Observable.of(new ConfigActions.SetTempConfigError(action.scope)));

	@Effect({dispatch: false}) showError$ = this._actions$
		.ofType<ConfigActions.LoadConfigError | ConfigActions.SaveConfigError>(
			ConfigActions.LOAD_CONFIG_ERROR, ConfigActions.SAVE_CONFIG_ERROR
		)
		.map(action => `WEBSERVICE_ERROR_${(action.payload || '').replace(/ /g, '_')}`)
		.map(msg => this._translate.has(msg) ? this._translate.translate(msg) : this._translate.translate('CONFIG_LOAD_ERROR'))
		.do(message => this._notifier.notify('error', message));

	@Effect({dispatch: false}) saveConfigSuccess$ = this._actions$
		.ofType<ConfigActions.SaveConfigSuccess>(ConfigActions.SAVE_CONFIG_SUCCESS)
		.do(() => this._notifier.notify('success', this._translate.translate('Speichern erfolgreich!')));


	constructor(
		private _actions$: Actions,
		private _config: ConfigService,
		private _translate: TranslateService,
		private _notifier: NotifierService,
		private _store: Store<State>
	) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/state-management/effects/config.ts